import $ from "jquery";

export const Homepage = function () {
	if (!($(".homepage").length > 0)) return false;

	const $elms = {
		teamList: $(".js-team-list"),
		openPopup: $(".js-open-popup"),
		closePopup: $(".js-close-popup"),
		layoutSelector: $(".role-starter--homepage"),
		fillDark: $(".filldark"),
		fillTransparent: $(".filltransparent"),
		roleCardNavigationItem: $(".js-role-card-navigation-item"),
		spiderChartPhase: $(".js-spider-chart-phase"),
		legendItems: {
			yourProfile: $("#legend-your-profile"),
			yourMissionGoals: $("#legend-your-mission-goals"),
			old: $("#legend-old"),
			growth: $("#legend-growth"),
			optionalGrowth: $("#legend-optional-growth"),
			coach: $("#legend-coach"),
			military: $("#legend-military"),
			social: $("#legend-social"),
			buddy: $("#legend-buddy"),
		},

		roleInfoBtn: $(".js-role"),
		roleCardPopup: $(".js-role-card-popup"),
		roleCardPopupClose: $(".js-role-card-popup-close"),
	};

	const gradientColorDark = $elms.layoutSelector.attr(
		"data-gradient-color-dark",
	);
	const gradientColorLight = $elms.layoutSelector.attr(
		"data-gradient-color-light",
	);

	$elms.openPopup.on("click", function () {
		$elms.teamList.addClass("is-active");
	});

	$elms.closePopup.on("click", function () {
		$elms.teamList.removeClass("is-active");
	});

	$elms.roleInfoBtn.on("click", function () {
		const learningGoalId = $(this).attr("data-learning-goal-id");
		const learningGoalColor = $(this).attr("data-color");
		$elms.roleCardPopup.removeClass("is-active");
		$elms.roleCardPopup
			.filter(`[data-learning-goal-id="${learningGoalId}"]`)
			.css("background-color", learningGoalColor)
			.addClass("is-active");
		
		$(".role-starter__header").addClass("is-hidden");
	});

	$elms.roleCardPopupClose.on("click", function () {
		$elms.roleCardPopup.removeClass("is-active");
		
		$(".role-starter__header").removeClass("is-hidden");
	});

	if (gradientColorDark && gradientColorLight) {
		$elms.fillDark.css("fill", gradientColorDark);
		$elms.fillTransparent.css("fill", gradientColorLight);
	}

	// Function to toggle legend items based on data attributes
	const toggleLegendItems = function ($navigationItem) {
		const dataAttributes = {
			yourProfile: $navigationItem.attr("data-has-your-profile"),
			yourMissionGoals: $navigationItem.attr("data-has-your-mission-goals"),
			// old: $navigationItem.attr("data-has-old"),
			growth: $navigationItem.attr("data-has-growth"),
			optionalGrowth: $navigationItem.attr("data-has-optional-growth"),
			// coach: $navigationItem.attr("data-has-coach"),
			// military: $navigationItem.attr("data-has-military"),
			// social: $navigationItem.attr("data-has-social"),
			// buddy: $navigationItem.attr("data-has-buddy"),
		};

		// Show/hide each legend item based on data attribute
		Object.keys(dataAttributes).forEach((key) => {
			const $legendItem = $elms.legendItems[key];
			if ($legendItem.length) {
				if (dataAttributes[key] === "1") {
					$legendItem.show();
				} else {
					$legendItem.hide();
				}
			}
		});
	};

	$elms.roleCardNavigationItem.on("click", function () {
		const $this = $(this);
		const dataPhase = $this.attr("data-phase");
		const $target = $elms.spiderChartPhase.filter(
			"[data-phase='" + dataPhase + "']",
		);
		if (!$target.length) {
			return;
		}

		$elms.roleCardNavigationItem.removeClass("is-active");
		$elms.spiderChartPhase.removeClass("is-active");

		$target.addClass("is-active");
		$this.addClass("is-active");

		// Toggle legend items based on the clicked navigation item's data attributes
		toggleLegendItems($this);
	});

	// Initialize legend items based on the active navigation item
	const $activeNavigationItem =
		$elms.roleCardNavigationItem.filter(".is-active");
	if ($activeNavigationItem.length) {
		toggleLegendItems($activeNavigationItem);
	}
};
